export function getPlanByModule(state) {
  return id => {
    let to_return = "error"
    state.planInfo.forEach(element => {
      if (element.Order == id) {
        if (element.havePlan) {
          to_return = element.plan
        }
      }
    });
    return to_return
  }
}

export function error(state, payload) {
  state.error = true
  state.errorMessage = payload
}

export function getModulePlans(state) {
  return state.planInfo
}


export function getOptions(state) {
  let response = []
  state.options.forEach(element => {
    response.push({
      value: element.id,
      text: element.name,
      extralabel: element.need_extra_data
    })
  });
  return response
}